// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MCcHmetQ83wDW_7Ti8hm,.UmBjgLXHhyMq2Gw6RLDI{gap:16px;width:100%;max-width:720px;display:flex}.MCcHmetQ83wDW_7Ti8hm{padding-top:16px}.MCcHmetQ83wDW_7Ti8hm,.UmBjgLXHhyMq2Gw6RLDI{flex-direction:column}.UmBjgLXHhyMq2Gw6RLDI{flex-direction:column-reverse}.pnYLvDoUYw9AITVI5J36{width:100%;height:23px;color:var(--content-primary-disabled);justify-content:center;align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `MCcHmetQ83wDW_7Ti8hm`,
	"messagesWrap": `UmBjgLXHhyMq2Gw6RLDI`,
	"date": `pnYLvDoUYw9AITVI5J36`
};
export default ___CSS_LOADER_EXPORT___;
